
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
} from "@mui/material";

export const EventoDialog = ({ open, setOpen, tarea }) => {
    if (!tarea) return null;

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleClose}
            fullWidth
            maxWidth={false}      // 🚨 permite que use todo el ancho disponible
            PaperProps={{
                sx: {
                    width: { xs: "90vw", md: "60vw" },  // 40% para pantallas pequeñas, 90% para medianas en adelante
                    height: { xs: "90vh", md: "60vh" },
                    maxWidth: { xs: "90vw", md: "60vw" },
                    maxHeight: { xs: "90vh", md: "60vh" },
                    m: "auto",
                },
            }}>
            <DialogTitle>{tarea.asunto}</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <Typography variant="body1">
                        <strong>Data:</strong> {tarea.fecha}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Hora d'inici:</strong> {tarea.hora_inicio}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Hora final:</strong> {tarea.hora_final}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Descripció:</strong> {tarea.descripcion}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose()} variant="contained" color="primary" zindex={1000}>
                    Tancar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
